import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
import InvisibleNumber from '@blade/common/components/invisible-number.vue';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import { getlibraries, getPortraitList } from '@blade-sxp/tools/apis';
let SelectPortrait = class SelectPortrait extends Vue {
    status;
    visible = true;
    librariesList = [];
    loading = false;
    multipleSelection = [];
    targetsList = [];
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    total = 1;
    pageSizes = [10, 20, 30, 40];
    portraitStatus = 'INVALIDATING'; // 失效
    // portraitStatus: string = 'NORMAL'; // 失效
    form = {
        name: '',
        identityId: '',
        libIdList: undefined,
        page: 1,
        size: this.pageSizes[0],
    };
    get disabled() {
        for (let i in this.form) {
            if (this.form[i])
                return false;
        }
        return true;
    }
    selectable(row) {
        // 判断是否失效禁用
        return !(row.portraitStatus === this.portraitStatus);
    }
    getTargets() {
        this.loading = true;
        getPortraitList(this.form)
            .then((res) => {
            this.targetsList = res.list;
            this.targetsList.forEach((it) => {
                it.imageUrl = it.image.path;
            });
            this.form.total = res.total;
            this.form.page = res.page;
            this.total = res.total;
            this.loading = false;
        })
            .catch((err) => {
            console.log('error:', err);
            this.$message.error(err?.data?.error || `${this.$t('common.serverError')}`);
            this.loading = false;
        });
    }
    getlibraries() {
        // this.loading = true;
        getlibraries({})
            .then((resp) => {
            // this.loading = false;
            this.librariesList = resp.list;
            // this.pagination.total = resp.data.data.total;
        })
            .catch((err) => {
            // this.loading = false;
            this.$message.error({ message: err, type: 'error' });
        });
    }
    handleSizeChange(val) {
        this.form.size = val;
        this.getTargets();
    }
    handleCurrentChange(val) {
        this.form.page = val;
        this.getTargets();
    }
    handleSubmit() {
        this.form.page = 1;
        this.getTargets();
    }
    onCallback(item) {
        return item;
    }
    created() {
        this.getTargets();
        this.getlibraries();
    }
};
__decorate([
    Prop()
], SelectPortrait.prototype, "status", void 0);
SelectPortrait = __decorate([
    Component({
        name: 'SelectPortrait',
        components: { AuthItem, InvisibleNumber, BlurPicture },
    })
], SelectPortrait);
export default SelectPortrait;
